import { EffectComposer, SSR, Bloom, LUT } from "@react-three/postprocessing";
// import { LUTCubeLoader } from 'postprocessing';
import useTransitionStore from "../../../state/transitions";
import useFogControlStore from "../../../state/fogControls";

export default function Effects({ sceneType = "auto" }) {
  const DisplayMode = useTransitionStore((s) => s.DisplayMode);
  const DayMode = useTransitionStore((s) => s.DayMode);
  const SuspensionMode = useTransitionStore((s) => s.SuspensionMode);
  const bloom = useFogControlStore((state) => state.bloom);
  const isNightLike = SuspensionMode || DayMode === "night" || DisplayMode === "flipper";
  const useTunedBloom =
    sceneType === "xr" ||
    (sceneType === "auto" &&
      DayMode === "day" &&
      DisplayMode !== "flipper" &&
      !SuspensionMode);

  const enabled = useTunedBloom ? bloom.enabled : true;
  const luminanceThreshold = useTunedBloom
    ? bloom.luminanceThreshold
    : DisplayMode == "powertrain"
    ? 0.64
    : isNightLike
    ? 0.7
    : 0.7;
  const luminanceSmoothing = useTunedBloom
    ? bloom.luminanceSmoothing
    : DisplayMode == "powertrain"
    ? 0.75
    : isNightLike
    ? 0.25
    : 0.25;
  const intensity = useTunedBloom
    ? bloom.intensity
    : DisplayMode == "powertrain"
    ? 6.4
    : isNightLike
    ? 4.08
    : 4.08;
  const mipmapBlur = useTunedBloom ? bloom.mipmapBlur : true;
  const radius = useTunedBloom
    ? bloom.radius
    : DisplayMode == "powertrain"
    ? 0.3
    : isNightLike
    ? 0.6
    : 0.73;
  return (
    enabled && (
      <EffectComposer disableNormalPass>
        {/* <SSR {...props} /> */}
        <Bloom
          radius={radius}
          // levels={}
          // blendFunction={}
          luminanceThreshold={luminanceThreshold}
          mipmapBlur={mipmapBlur}
          luminanceSmoothing={luminanceSmoothing}
          intensity={intensity}
        />
        {/* <LUT lut={texture} /> */}
      </EffectComposer>
    )
  );
}
